var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page bg-grey" },
    [
      _c("step-section"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "filter-mobile-togler" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "toggler d-flex" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "toggler-btn ml-auto",
                on: {
                  click: function($event) {
                    return _vm.showfilters()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "filter-img",
                  attrs: {
                    src: require("../../../img/icon/Filter_icn_black.svg")
                  }
                }),
                _vm._v("Filters (6)\n")
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "offer-filter new-filter",
          class: { mobile: _vm.isMobile, "mobile-open": _vm.mobileOpen }
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c("div", { staticClass: "toggler-row mobile" }, [
                    _c("p", { staticClass: "min p-bold p-center" }, [
                      _vm._v("Pick filter")
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close-btn ",
                        class: { active: _vm.showfilter },
                        on: { click: _vm.showfilters }
                      },
                      [_vm._v("Close filter")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "toggler-row desktop" }, [
                    _c(
                      "button",
                      {
                        staticClass: "toggler-btn",
                        class: { active: _vm.showfilter },
                        on: {
                          click: function($event) {
                            _vm.showfilter = !_vm.showfilter
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "filter-img",
                          attrs: {
                            src: require("../../../img/icon/Filter_icn_black.svg")
                          }
                        }),
                        _vm._v("Filters (6)  "),
                        _c("img", {
                          staticClass: "filter-arrow",
                          attrs: {
                            src: "/img/icon/arrow-black-v2.svg",
                            alt: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.showfilter
                      ? _c("div", { staticClass: "main-filter open" }, [
                          _c(
                            "div",
                            { staticClass: "row justify-content-between" },
                            [
                              _c("div", { staticClass: "col-md-6 col-lg-5" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.closetoogleshow4,
                                        expression: "closetoogleshow4"
                                      }
                                    ],
                                    staticClass:
                                      "filter-blck filter-dropdown big-dropdown"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "label min p-bold p-dgrey"
                                      },
                                      [
                                        _vm._v("Contract type "),
                                        _c("span", {
                                          staticClass: "quest__in_icon",
                                          class: { active: _vm.active1 },
                                          on: {
                                            click: function($event) {
                                              _vm.active1 = !_vm.active1
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.active1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "mini-popup",
                                                class: { active: _vm.active1 },
                                                on: {
                                                  click: function($event) {
                                                    _vm.active1 = !_vm.active1
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "m_popup__blck"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "title" },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "Raleway min p-dgrey"
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "Variable price"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "content"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "min-min p-dgrey"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "main-dropdown" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-white btn-full small dropdown",
                                            class: { active: _vm.show4 },
                                            on: {
                                              click: function($event) {
                                                _vm.show4 = !_vm.show4
                                              }
                                            }
                                          },
                                          [_vm._v("All types")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "transition",
                                          { attrs: { name: "fade" } },
                                          [
                                            _vm.show4
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "dropdown__el"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "dropdown-list"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-item"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/icon/all-contract.svg"),
                                                                alt: ""
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox",
                                                                    title:
                                                                      "title"
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "box"
                                                                })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("label", [
                                                              _vm._v(
                                                                "All types"
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-item"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/icon/fixed-contract.svg"),
                                                                alt: ""
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox",
                                                                    title:
                                                                      "title"
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "box"
                                                                })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("label", [
                                                              _vm._v(
                                                                "Fixed price"
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-item"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/icon/variable-contract.svg"),
                                                                alt: ""
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox",
                                                                    title:
                                                                      "title"
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "box"
                                                                })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("label", [
                                                              _vm._v(
                                                                "Variable price"
                                                              )
                                                            ])
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-item"
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: require("../../../img/icon/mix-contract.svg"),
                                                                alt: ""
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox"
                                                              },
                                                              [
                                                                _c("input", {
                                                                  attrs: {
                                                                    type:
                                                                      "checkbox",
                                                                    title:
                                                                      "title"
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "box"
                                                                })
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("label", [
                                                              _vm._v(
                                                                "Mix price"
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6 col-lg-6" }, [
                                _c("div", { staticClass: "checkbox-btn" }, [
                                  _c(
                                    "div",
                                    { staticClass: "label min p-bold p-dgrey" },
                                    [
                                      _vm._v("Binding time "),
                                      _c("span", {
                                        staticClass: "quest__in_icon",
                                        class: { active: _vm.active1 },
                                        on: {
                                          click: function($event) {
                                            _vm.active1 = !_vm.active1
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.active1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "mini-popup",
                                              class: { active: _vm.active1 },
                                              on: {
                                                click: function($event) {
                                                  _vm.active1 = !_vm.active1
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "m_popup__blck"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "title" },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "Raleway min p-dgrey"
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "Variable price"
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "content" },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "min-min p-dgrey"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added."
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "checks-list" }, [
                                    _c(
                                      "div",
                                      { staticClass: "checkbox-item" },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            value: "1",
                                            name: "checkbox-item"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("All")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "checkbox-item" },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            value: "1",
                                            name: "checkbox-item"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Without binding")])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "checkbox-item" },
                                      [
                                        _c("input", {
                                          attrs: {
                                            type: "radio",
                                            value: "1",
                                            name: "checkbox-item"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("With binding")])
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.closetoogleshow,
                                      expression: "closetoogleshow"
                                    }
                                  ],
                                  staticClass: "filter-blck filter-dropdown"
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "min  p-bold p-dgrey" },
                                    [_vm._v("Payment method ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-white btn-full small dropdown",
                                      class: { active: _vm.show },
                                      on: {
                                        click: function($event) {
                                          _vm.show = !_vm.show
                                        }
                                      }
                                    },
                                    [_vm._v("E-faktura")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _vm.show
                                        ? _c(
                                            "div",
                                            { staticClass: "dropdown__el" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown-list"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/autogiro.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("Autogiro")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/check.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("E-faktura")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/file.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("Traditionell")
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.closetoogleshow2,
                                      expression: "closetoogleshow2"
                                    }
                                  ],
                                  staticClass: "filter-blck filter-dropdown"
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "min  p-bold p-dgrey" },
                                    [_vm._v("Choose production sources")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-white btn-full small dropdown",
                                      class: { active: _vm.show2 },
                                      on: {
                                        click: function($event) {
                                          _vm.show2 = !_vm.show2
                                        }
                                      }
                                    },
                                    [_vm._v("Some long text without dashes")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _vm.show2
                                        ? _c(
                                            "div",
                                            { staticClass: "dropdown__el" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown-list"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/weather/sun.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("Sun")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/weather/wind.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("Wind")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/weather/drop.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("Water")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/weather/leaf.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v("Nature")
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            "/img/icon/weather/ecology.svg",
                                                          alt: ""
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox"
                                                        },
                                                        [
                                                          _c("input", {
                                                            attrs: {
                                                              type: "checkbox",
                                                              title: "title"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass: "box"
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("label", [
                                                        _vm._v(
                                                          "Good environmental choice"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6 col-lg-3" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "click-outside",
                                      rawName: "v-click-outside",
                                      value: _vm.closetoogleshow3,
                                      expression: "closetoogleshow3"
                                    }
                                  ],
                                  staticClass: "filter-blck filter-dropdown"
                                },
                                [
                                  _c(
                                    "label",
                                    { staticClass: "min  p-bold p-dgrey" },
                                    [_vm._v("Sort by")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-white btn-full small dropdown",
                                      class: { active: _vm.show3 },
                                      on: {
                                        click: function($event) {
                                          _vm.show3 = !_vm.show3
                                        }
                                      }
                                    },
                                    [_vm._v("All types")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "transition",
                                    { attrs: { name: "fade" } },
                                    [
                                      _vm.show3
                                        ? _c(
                                            "div",
                                            { staticClass: "dropdown__el" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "dropdown-list"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          "Fixed price 6 months"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          "Fixed price 6 months"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          "Fixed price 6 months"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          "Fixed price 6 months"
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "dropdown-item"
                                                    },
                                                    [
                                                      _c("label", [
                                                        _vm._v(
                                                          "Fixed price 6 months"
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-6 col-lg-3 d-flex align-items-end justify-content-start"
                              },
                              [
                                _c("div", { staticClass: "filter-blck eco" }, [
                                  _c("span", { staticClass: "checkbox" }, [
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        title: "title"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "box" })
                                  ]),
                                  _vm._v(" "),
                                  _c("label", { staticClass: "min p-dgrey" }, [
                                    _vm._v("Good environmental choice")
                                  ]),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src: "/img/icon/ecology.svg",
                                      alt: ""
                                    }
                                  })
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "action-btn" }, [
                            _c("button", { staticClass: "btn" }, [
                              _vm._v("Reset filters(2)")
                            ]),
                            _vm._v(" "),
                            _c("button", { staticClass: "result" }, [
                              _vm._v("188 results")
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "filter-result" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.res, function(resultItem, key) {
              return _c("new-offer-result-item", {
                key: key,
                attrs: {
                  itemData: resultItem,
                  keyItem: key,
                  localItem: resultItem.localItem
                },
                on: {
                  modalActive: function($event) {
                    return _vm.openModal()
                  }
                }
              })
            }),
            1
          )
        ]),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _vm.modal
          ? _c("div", { staticClass: "info-popup open" }, [
              _c("div", {
                staticClass: "popupoverlay",
                on: {
                  click: function($event) {
                    return _vm.openModal()
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mainpopup" }, [
                _c("div", {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      return _vm.openModal()
                    }
                  }
                }),
                _vm._v(" "),
                _vm._m(4)
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("fixed-ad-el")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "offer-title" }, [
      _c("div", { staticClass: "bg-title" }, [
        _c(
          "div",
          {
            staticClass: "title_sect bg-img",
            staticStyle: {
              "background-image": "url('../../../img/stockholm-market.png')"
            }
          },
          [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("h1", { staticClass: "relawaySM p-title" }, [
                    _vm._v("Compare electricity in Stockholm")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "min-med p-white Raleway" }, [
                    _vm._v("We found "),
                    _c("b", [_vm._v("188")]),
                    _vm._v("  electricity contracts for postcode: "),
                    _c("b", [_vm._v("45134")])
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title_sect bg-color pb-0" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "h1",
              { staticClass: "relawayBold p-title d-flex align-items-center" },
              [
                _vm._v("Result for postcode  45134 "),
                _c("span", { staticClass: "marker" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../img/marker-black.svg"),
                      alt: ""
                    }
                  }),
                  _vm._v("Stockholm")
                ])
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "min-med Raleway" }, [_vm._v("188 results")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "marker" }, [
      _c("img", {
        attrs: { src: require("../../../img/marker-black.svg"), alt: "" }
      }),
      _vm._v("Stockholm")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "pagination" }, [
        _c("div", { staticClass: "prev" }, [
          _c("a", { staticClass: "btn-prev btn-page", attrs: { href: "#" } }, [
            _c("img", {
              attrs: {
                src: require("../../../img/icon/arrow-white-v2.svg"),
                alt: ""
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-list" }, [
          _c("span", [_c("a", { attrs: { href: "#" } }, [_vm._v("1")])]),
          _vm._v(" "),
          _c("span", [
            _c("a", { staticClass: "current", attrs: { href: "#" } }, [
              _vm._v("2")
            ])
          ]),
          _vm._v(" "),
          _c("span", [_c("a", { attrs: { href: "#" } }, [_vm._v("3")])]),
          _vm._v(" "),
          _c("span", [_c("span", { staticClass: "dotted" }, [_vm._v("...")])]),
          _vm._v(" "),
          _c("span", [
            _c("a", { staticClass: "last", attrs: { href: "#" } }, [
              _vm._v("25")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "next" }, [
          _c("a", { staticClass: "btn-next btn-page", attrs: { href: "#" } }, [
            _c("img", {
              attrs: {
                src: require("../../../img/icon/arrow-white-v2.svg"),
                alt: ""
              }
            })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "popup_body" }, [
      _c("div", { staticClass: "title" }, [
        _c("p", { staticClass: "p-black p-bold  med" }, [
          _c("b", [_vm._v("Info")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("p", { staticClass: "min-min" }, [
          _vm._v(
            "It is currently not possible to get our help with the change to this company, as they lack a cooperation with el skling.se.\n                            "
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "If you want our free help with changing here and now, we suggest the next possible agreement in your list. For you it is Skellefteå Kraft AB's 36 month agreement. The difference in annual cost is -1223 SEK. Skellefteå Kraft AB's agreement is also an environmental agreement. "
          )
        ]),
        _vm._v(" "),
        _c("p", [_vm._v(" Would this agreement fit in instead?")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "submit__btn" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c("button", { staticClass: "btn btn-green btn-full small" }, [
              _vm._v("AND")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c("button", { staticClass: "btn btn-white btn-full small" }, [
              _vm._v("NO")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }